import { Component, OnInit, OnDestroy, Input, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthenticationService } from 'app/auth/service';
import { User } from 'app/auth/models';
import { CoreConfigService } from '@core/services/config.service';

@Component({
  selector: 'app-sidebar-footer',
  templateUrl: './sidebar-footer.component.html',
  styleUrls: ['./sidebar-footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarFooterComponent implements OnInit, OnDestroy {
  @Input() isCollapsed: boolean = false;

  public currentUser: User;
  public currentSkin: string = 'default';

  private _unsubscribeAll: Subject<any>;

  constructor(
    private _authenticationService: AuthenticationService,
    private _coreConfigService: CoreConfigService
  ) {
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this._authenticationService.currentUser
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(user => {
        this.currentUser = user;
      });

    this._coreConfigService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(config => {
        this.currentSkin = config.layout.skin;
      });
  }

  toggleDarkSkin(): void {
    this._coreConfigService
      .getConfig()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(config => {
        this.currentSkin = config.layout.skin;
      });

    const prevSkin = localStorage.getItem('prevSkin');

    if (this.currentSkin === 'dark') {
      this._coreConfigService.setConfig(
        { layout: { skin: prevSkin ? prevSkin : 'default' } },
        { emitEvent: true }
      );
    } else {
      localStorage.setItem('prevSkin', this.currentSkin);
      this._coreConfigService.setConfig(
        { layout: { skin: 'dark' } },
        { emitEvent: true }
      );
    }
  }

  get currentUserInitial(): string {
    const name = this.currentUser?.fullName || this.currentUser?.username || 'A';
    return name.charAt(0).toUpperCase();
  }

  get currentUserEmail(): string {
    return this.currentUser?.email || this.currentUser?.username || 'admin@cmc.com.vn';
  }

  logout(): void {
    this._authenticationService.logout();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}

